import { Route, Routes } from 'react-router-dom';
import ScrollToTop from 'react-scroll-up';
import { RxThickArrowUp } from 'react-icons/rx';

import NotFoundPage from 'pages/NotFoundPage/NotFoundPage';
import SharedLayout from 'components/SharedLayout/SharedLayout';
import ScrollWrapper from 'components/ScrollToUp/ScrollWrapper';
import scrollToTopStyle from 'components/ScrollToUp/ScrollToTopStyle';

import { appRoutes } from 'routes/routes';
import img777 from './images/777.jpg';

const DISABLED = false;
const App = () => {
  if (DISABLED) {
    return (
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <h1>
          Игра мертвая. Нет баланса, плохой подбор, плохое соединение с
          серверами и постоянные вылеты из боев ( противник не смог попасть в
          бой, а на самом деле он в бою и бой идет без тебя), много ошибок,
          безразличие разработчиков к проблемам. 6 лет назад игрок Trefff
          озвучивал все эти проблемы - прошло 6 лет, а в игре ровно ничего не
          поменялось в плане подхода к игре и игрокам.
          {}
          <p></p>
          <p>
            The game is dead. There's no balance, poor matchmaking, poor server
            connections, and crashes (the enemy couldn't join the battle, but in
            reality, they're in the battle and the battle is going on without
            you), lots of bugs, and the developers are indifferent to the
            problems. Six years ago, player Trefff voiced all these problems –
            six years have passed, and absolutely nothing has changed in the
            game's approach to the game and its players.
          </p>
        </h1>
        <img src={img777} alt="img" />
      </div>
    );
  }
  return (
    <>
      <Routes>
        <Route path="/" element={<SharedLayout />}>
          {appRoutes.map(({ path, element, children }) => (
            <Route key={path} path={path} element={element}>
              {children &&
                children.map(({ path, element }) => (
                  <Route key={path} path={path} element={element} />
                ))}
            </Route>
          ))}
        </Route>
        <Route path="*" element={<NotFoundPage />} />
      </Routes>

      <ScrollToTop showUnder={100} style={scrollToTopStyle}>
        <ScrollWrapper>
          <RxThickArrowUp size="28" strokeWidth="0.2px" />
        </ScrollWrapper>
      </ScrollToTop>
    </>
  );
};

export default App;
